// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1vMrn","col":"styles_col__2dNMO"};